export default "__VITE_ASSET__bec93bff__"